var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticketDetail"},[_c('detail',{attrs:{"goods_info":_vm.goods_details}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }